import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationBanner } from '../elements-banner/notification-banner';
import Button from '../elements-buttons/Button';
import { PaymentsTable } from '../elements-tables/payments-table/PaymentsTable';
import { BookingRequestSummary } from '../elements-summaries/booking-request-summary/BookingRequestSummary';

export const PaymentDetailsMain = ({
  payment,
  normalizedContracts,
  intl,
  routeParams,
  router,
  booking,
  profile
}) => {
  const [bannerText, setBannerText] = useState('');

  const [processedPayments, upcomingPayments] = (payment?.data?.objects || [])
    .filter((p) => p.category === 'booking')
    .reduce(
      (paymentArrs, currPayment) => {
        if (currPayment.obj_state === 'SCHEDULED') {
          paymentArrs[1].push(currPayment);
        } else {
          paymentArrs[0].push(currPayment);
        }
        return paymentArrs;
      },
      [[], []]
    );

  const { masterContract } = normalizedContracts;
  const isSplitPaymentBooking = masterContract?.split_payment_checkout;
  const hasUncapturedPayment = masterContract?.balance_split_payments;
  const settleBalanceRequired =
    masterContract?.state === 'SETTLE_BALANCE_REQUIRED' ||
    masterContract?.state === 'GUEST_SETTLE_BALANCE_NO_AUTH';
  const isActiveBooking = get(booking, 'booking.obj_state') === 'ACTIVE';

  // only available for accepted split payment bookings with an upcoming or a failed payment
  let showUpdatePaymentCta =
    isActiveBooking &&
    isSplitPaymentBooking &&
    (hasUncapturedPayment || settleBalanceRequired);

  useEffect(() => {
    const paymentMethodUpdated = get(
      router,
      'location.state.paymentUpdateSuccess'
    );
    if (paymentMethodUpdated) {
      setBannerText(
        intl.formatMessage({
          id: 'inbox.payment-details.payment-method-updated',
          defaultMessage: 'Your payment method was updated'
        })
      );
    }
  }, []);

  return (
    <>
      {!!bannerText && (
        <NotificationBanner
          showClose={true}
          closeBanner={() => setBannerText('')}
          message={bannerText}
        />
      )}
      <div
        className='ps-container-lg-margin ps-container-fixed'
        style={{
          paddingTop: '64px'
        }}
      >
        <div className='ps-row'>
          <h2 className='h3 col-sm-12'>
            <FormattedMessage
              id='inbox.payment_details_main.payments'
              defaultMessage='Payments'
            />
          </h2>
          <div className='margin-md-top margin-xl-bottom col-md-7 col-sm-12 left-column"'>
            <div className='margin-xl-bottom'>
              <div>
                <h5 className='padding-lg-top'>
                  <FormattedMessage
                    id='inbox.current_details_main.processed'
                    defaultMessage='Processed'
                  />
                </h5>
                <div data-testing-id='processed-payments-table-container'>
                  <PaymentsTable payments={processedPayments} intl={intl} />
                </div>
                {!!upcomingPayments.length && (
                  <div className='margin-xl-top'>
                    <h5>
                      <FormattedMessage
                        id='inbox.current_details_main.upcoming'
                        defaultMessage='Upcoming'
                      />
                    </h5>
                    <div data-testing-id='upcoming-payments-table-container'>
                      <PaymentsTable
                        payments={upcomingPayments}
                        isUpcoming={true}
                        intl={intl}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='flex space-between'>
              <Button
                className='btn btn-default classic'
                onClick={() => {
                  router.push({
                    pathname: `/inbox/${routeParams?.bookingID}`
                  });
                }}
              >
                <FormattedMessage
                  id='inbox.update_payment_main.back'
                  defaultMessage='Back'
                />
              </Button>
              {showUpdatePaymentCta && (
                <Button
                  category='primary'
                  classNameString='btn btn-primary'
                  attributes={{
                    'data-testing-id': 'update-payment-cta'
                  }}
                  onClick={() => {
                    router.push({
                      pathname: `/inbox/${routeParams?.bookingID}/update-payment`
                    });
                  }}
                >
                  <FormattedMessage
                    id='payment_details_main.update_payment_method'
                    defaultMessage='Update payment method'
                  />
                </Button>
              )}
            </div>
          </div>
          <div
            className='margin-md-top col-md-5 col-sm-12'
            data-testing-id='summary-container'
          >
            <BookingRequestSummary
              booking={normalizedContracts?.bookingObject}
              listing={normalizedContracts?.spaceRentalContract?.meta.listing}
              masterContract={normalizedContracts?.masterContract}
              addOnsContracts={normalizedContracts?.items}
              profile={profile}
              intl={intl}
            />
          </div>
        </div>
      </div>
    </>
  );
};
